






import { listFactory } from '@/main/pages';

import { VOZIDLO_RIDIC } from './constants';
import { store } from './store/vozidloRidicList';

export default listFactory(VOZIDLO_RIDIC, store);
